module.exports = __webpack_public_path__ + "img/zhanli-drop3.788c464f.png";